import { render, staticRenderFns } from "./ProjectBackButton.vue?vue&type=template&id=7155e704&"
import script from "./ProjectBackButton.vue?vue&type=script&lang=js&"
export * from "./ProjectBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports